import React from "react";
import "./ResoOfferSection.css";

export default function ResoOfferSection() {
  return (
    <section className="reso-offer-container">

      {/* ---------- SECTION 1 (IMAGE LEFT + TEXT RIGHT) ---------- */}
      <div className="reso-offer-row reso-offer-normal">

        {/* LEFT IMAGE */}
        <div className="reso-offer-image-box">
          <img
            src="/images/reso1.png"
            alt="Offer Letters"
            className="reso-offer-image"
          />

          {/* Floating Badge */}
          <div className="reso-offer-badge">
            <h4>248 Letters Sent</h4>
            <p>You issued 12 more offer letters this month.</p>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="reso-offer-content">
          <h2 className="reso-offer-title">
            Create <span>Offer</span> Letters Effortlessly
          </h2>

          <p className="reso-offer-desc">
            Generate professional, accurate, and fully customizable offer
            letters in seconds. Streamline your hiring process, ensure
            compliance, and deliver a seamless experience for new hires with our
            automated offer-letter generation platform.
          </p>

          <button className="reso-offer-btn">Start Now →</button>
        </div>
      </div>


      {/* ---------- SECTION 2 (TEXT LEFT + IMAGE RIGHT) ---------- */}
      <div className="reso-offer-row reso-offer-reverse">

        {/* LEFT CONTENT */}
        <div className="reso-offer-content">
          <h2 className="reso-offer-title">
            Get real-time <span>approval workflows</span>
          </h2>

          <p className="reso-offer-desc">
            With our intuitive workflow system, stay on top of every request and make 
            faster, more informed decisions ensuring smoother operations, improved 
            compliance, and complete process visibility.
          </p>

          <ul className="reso-offer-list">
            <li>✔ Instant insights into pending and completed requests.</li>
            <li>✔ Enhanced transparency across every workflow.</li>
            <li>✔ Real-time approval tracking.</li>
          </ul>

          <a className="reso-offer-link" href="#">
            Manage Approvals →
          </a>
        </div>

        {/* RIGHT IMAGE */}
        <div className="reso-offer-image-box">
          <img
            src="/images/reso2.jpg"
            alt="Workflow"
            className="reso-offer-image"
          />

          <div className="reso-offer-chart">
            <img src="/images/chart.png" alt="Chart" />
          </div>
        </div>
      </div>

    </section>
  );
}
